import type { ReactElement } from 'react';
import { STORE_DETAIL_PROCESS_ID } from '@/shared/config';
import { ProductionStepCard } from './production-step-card';
import { PRODUCTION_STEPS } from './production-steps';

/**
 * 제작 과정 — 상품 상세의 상세 설명 끝(후기 앞)에 두는 여섯 단계 안내. 모든 상품에 같은 문구다.
 * 상세 설명·후기와 같은 굵은 밑선 제목, 그 아래 가는 선으로 나눈 3열(좁으면 2열·1열) 격자.
 */
export const ProductionProcess = (): ReactElement => (
  <section aria-labelledby={STORE_DETAIL_PROCESS_ID} className="mt-24 scroll-mt-28">
    <div className="flex flex-col gap-3 border-b border-foreground pb-4 sm:flex-row sm:items-end sm:justify-between">
      <h2
        id={STORE_DETAIL_PROCESS_ID}
        className="text-2xl leading-tight font-bold tracking-[-0.02em]"
      >
        제작 과정
      </h2>
      <p className="text-sm text-muted-foreground">
        상품을 고른 뒤 받아 보기까지, 여섯 단계로 진행됩니다.
      </p>
    </div>
    <ol className="mt-8 grid gap-x-8 gap-y-10 sm:grid-cols-2 lg:grid-cols-3">
      {PRODUCTION_STEPS.map((step, index) => (
        <ProductionStepCard key={step.title} order={index + 1} step={step} />
      ))}
    </ol>
  </section>
);
